jQuery(function($)
{
    var
        $terms = $('#terms'),
        $termsTrigger = $('#terms-accepted'),
        $downloadTriggers = $('.download-trigger');

    var $downloadCopyLinkTrigger = $('.js-download-accepted');

    if (localStorage.getItem('download-accepted'))
    {
        $downloadTriggers.each(function()
        {
            $(this).removeClass('overlay-trigger');
        });
        $downloadCopyLinkTrigger.each(function()
        {
            $(this).removeClass('hidden');
        });
    }

    function isRead($element)
    {
        return $element[0].scrollTop + $element.height() >= $element[0].scrollHeight - 40; // include padding 40
    }

    $terms.scroll(function()
    {
        if (isRead($terms))
        {
            $termsTrigger.removeClass('disabled');
        }
    });

    $downloadTriggers.on('click', function()
    {
        $termsTrigger.attr('href', $(this).attr('href'));
    });

    $termsTrigger.on('click', function()
    {
        localStorage.setItem('download-accepted', '1');
        $downloadTriggers.each(function()
        {
            $(this).removeClass('overlay-trigger');
        });
        $downloadCopyLinkTrigger.each(function()
        {
            $(this).removeClass('hidden');
        });
    });
});
